/*
 * @Author: sz
 * @Date: 2023-11-28 18:30:45
 * @LastEditors: sz
 * @LastEditTime: 2023-12-04 14:10:58
 * @FilePath: \hisea-ssr\src\components\TextInput\textInput.js
 * @Description:
 */
import { useStyle } from '@/classify';
import useFieldState from '@/common/hooks/hook-wrappers/useInformedFieldStateWrapper';
import { cn } from '@/lib/utils';
import { Input as InformedText } from 'informed';
import { Fragment, forwardRef } from 'react';
import { FieldIcons, Message } from '../Field';
import defaultClasses from './textInput.module.css';
const TextInput = forwardRef((props, ref) => {
  const { after, before, classes: propClasses, expandClasses, field, message, ...rest } = props;

  const fieldState = useFieldState(field);
  const classes = useStyle(defaultClasses, propClasses);
  const inputClass = fieldState.error ? classes.input_error : classes.input;
  const messageClass = classes.message;

  // 网站所有的输入框，只有在提交的时候才需要给到必填提示语；
  const maybeIcons =
    after || before ? (
      <FieldIcons
        after={after}
        before={before}
      >
        <InformedText
          {...rest}
          className={cn(inputClass, expandClasses?.inputClass)}
          field={field}
          validateOn='submit'
        />
      </FieldIcons>
    ) : (
      <InformedText
        {...rest}
        className={cn(inputClass, expandClasses?.inputClass)}
        field={field}
        validateOn='submit'
      />
    );

  return (
    <Fragment>
      {maybeIcons}
      <Message
        fieldState={fieldState}
        className={messageClass}
      >
        {message}
      </Message>
    </Fragment>
  );
});

export default TextInput;
